"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _activity = _interopRequireDefault(require("../../../../assets/icons/activity.svg")),
    _addfat = _interopRequireDefault(require("../../../../assets/icons/addfat.svg")),
    _addthin = _interopRequireDefault(require("../../../../assets/icons/addthin.svg")),
    _admin = _interopRequireDefault(require("../../../../assets/icons/admin.svg")),
    _alert = _interopRequireDefault(require("../../../../assets/icons/alert.svg")),
    _aligncenter = _interopRequireDefault(require("../../../../assets/icons/aligncenter.svg")),
    _alignjustified = _interopRequireDefault(require("../../../../assets/icons/alignjustified.svg")),
    _alignleft = _interopRequireDefault(require("../../../../assets/icons/alignleft.svg")),
    _alignright = _interopRequireDefault(require("../../../../assets/icons/alignright.svg")),
    _analytics = _interopRequireDefault(require("../../../../assets/icons/analytics.svg")),
    _apps = _interopRequireDefault(require("../../../../assets/icons/apps.svg")),
    _arabic = _interopRequireDefault(require("../../../../assets/icons/arabic.svg")),
    _arrowdown = _interopRequireDefault(require("../../../../assets/icons/arrowdown.svg")),
    _arrowleft = _interopRequireDefault(require("../../../../assets/icons/arrowleft.svg")),
    _arrowright = _interopRequireDefault(require("../../../../assets/icons/arrowright.svg")),
    _arrowup = _interopRequireDefault(require("../../../../assets/icons/arrowup.svg")),
    _at = _interopRequireDefault(require("../../../../assets/icons/at.svg")),
    _audio = _interopRequireDefault(require("../../../../assets/icons/audio.svg")),
    _blockquote = _interopRequireDefault(require("../../../../assets/icons/blockquote.svg")),
    _bold = _interopRequireDefault(require("../../../../assets/icons/bold.svg")),
    _bookings = _interopRequireDefault(require("../../../../assets/icons/bookings.svg")),
    _bookmark = _interopRequireDefault(require("../../../../assets/icons/bookmark.svg")),
    _brand = _interopRequireDefault(require("../../../../assets/icons/brand.svg")),
    _brief = _interopRequireDefault(require("../../../../assets/icons/brief.svg")),
    _briefbasic = _interopRequireDefault(require("../../../../assets/icons/briefbasic.svg")),
    _briefexact = _interopRequireDefault(require("../../../../assets/icons/briefexact.svg")),
    _brightcove = _interopRequireDefault(require("../../../../assets/icons/brightcove.svg")),
    _broadcast = _interopRequireDefault(require("../../../../assets/icons/broadcast.svg")),
    _brokenlink = _interopRequireDefault(require("../../../../assets/icons/brokenlink.svg")),
    _bulletlist = _interopRequireDefault(require("../../../../assets/icons/bulletlist.svg")),
    _bulletnumeric = _interopRequireDefault(require("../../../../assets/icons/bulletnumeric.svg")),
    _camera = _interopRequireDefault(require("../../../../assets/icons/camera.svg")),
    _captions = _interopRequireDefault(require("../../../../assets/icons/captions.svg")),
    _chevrondown = _interopRequireDefault(require("../../../../assets/icons/chevrondown.svg")),
    _chevronleft = _interopRequireDefault(require("../../../../assets/icons/chevronleft.svg")),
    _chevronright = _interopRequireDefault(require("../../../../assets/icons/chevronright.svg")),
    _chevronup = _interopRequireDefault(require("../../../../assets/icons/chevronup.svg")),
    _childpage = _interopRequireDefault(require("../../../../assets/icons/childpage.svg")),
    _chromakey = _interopRequireDefault(require("../../../../assets/icons/chromakey.svg")),
    _close = _interopRequireDefault(require("../../../../assets/icons/close.svg")),
    _colour = _interopRequireDefault(require("../../../../assets/icons/colour.svg")),
    _corrupt = _interopRequireDefault(require("../../../../assets/icons/corrupt.svg")),
    _comments = _interopRequireDefault(require("../../../../assets/icons/comments.svg")),
    _company = _interopRequireDefault(require("../../../../assets/icons/company.svg")),
    _computer = _interopRequireDefault(require("../../../../assets/icons/computer.svg")),
    _contract = _interopRequireDefault(require("../../../../assets/icons/contract.svg")),
    _creative = _interopRequireDefault(require("../../../../assets/icons/creative.svg")),
    _credits = _interopRequireDefault(require("../../../../assets/icons/credits.svg")),
    _dashboard = _interopRequireDefault(require("../../../../assets/icons/dashboard.svg")),
    _defscreen = _interopRequireDefault(require("../../../../assets/icons/defscreen.svg")),
    _desktop = _interopRequireDefault(require("../../../../assets/icons/desktop.svg")),
    _document = _interopRequireDefault(require("../../../../assets/icons/document.svg")),
    _download = _interopRequireDefault(require("../../../../assets/icons/download.svg")),
    _duplicate = _interopRequireDefault(require("../../../../assets/icons/duplicate.svg")),
    _edit = _interopRequireDefault(require("../../../../assets/icons/edit.svg")),
    _editing = _interopRequireDefault(require("../../../../assets/icons/editing.svg")),
    _email = _interopRequireDefault(require("../../../../assets/icons/email.svg")),
    _embed = _interopRequireDefault(require("../../../../assets/icons/embed.svg")),
    _exit = _interopRequireDefault(require("../../../../assets/icons/exit.svg")),
    _expand = _interopRequireDefault(require("../../../../assets/icons/expand.svg")),
    _export = _interopRequireDefault(require("../../../../assets/icons/export.svg")),
    _extrafootage = _interopRequireDefault(require("../../../../assets/icons/extrafootage.svg")),
    _facebook = _interopRequireDefault(require("../../../../assets/icons/facebook.svg")),
    _facebook2 = _interopRequireDefault(require("../../../../assets/icons/facebook2.svg")),
    _faq = _interopRequireDefault(require("../../../../assets/icons/faq.svg")),
    _fastforward = _interopRequireDefault(require("../../../../assets/icons/fastforward.svg")),
    _favempty = _interopRequireDefault(require("../../../../assets/icons/favempty.svg")),
    _favfull = _interopRequireDefault(require("../../../../assets/icons/favfull.svg")),
    _favourite = _interopRequireDefault(require("../../../../assets/icons/favourite.svg")),
    _flag = _interopRequireDefault(require("../../../../assets/icons/flag.svg")),
    _flagar = _interopRequireDefault(require("../../../../assets/icons/flagar.svg")),
    _flagaus = _interopRequireDefault(require("../../../../assets/icons/flagaus.svg")),
    _flagbr = _interopRequireDefault(require("../../../../assets/icons/flagbr.svg")),
    _flagch = _interopRequireDefault(require("../../../../assets/icons/flagch.svg")),
    _flagcs = _interopRequireDefault(require("../../../../assets/icons/flagcs.svg")),
    _flagcz = _interopRequireDefault(require("../../../../assets/icons/flagcz.svg")),
    _flagde = _interopRequireDefault(require("../../../../assets/icons/flagde.svg")),
    _flagdu = _interopRequireDefault(require("../../../../assets/icons/flagdu.svg")),
    _flages = _interopRequireDefault(require("../../../../assets/icons/flages.svg")),
    _flageuro = _interopRequireDefault(require("../../../../assets/icons/flageuro.svg")),
    _flagfr = _interopRequireDefault(require("../../../../assets/icons/flagfr.svg")),
    _flaggen = _interopRequireDefault(require("../../../../assets/icons/flaggen.svg")),
    _flaggpt = _interopRequireDefault(require("../../../../assets/icons/flaggpt.svg")),
    _flagit = _interopRequireDefault(require("../../../../assets/icons/flagit.svg")),
    _flagja = _interopRequireDefault(require("../../../../assets/icons/flagja.svg")),
    _flagjp = _interopRequireDefault(require("../../../../assets/icons/flagjp.svg")),
    _flagko = _interopRequireDefault(require("../../../../assets/icons/flagko.svg")),
    _flagkr = _interopRequireDefault(require("../../../../assets/icons/flagkr.svg")),
    _flagnl = _interopRequireDefault(require("../../../../assets/icons/flagnl.svg")),
    _flagpl = _interopRequireDefault(require("../../../../assets/icons/flagpl.svg")),
    _flagpt = _interopRequireDefault(require("../../../../assets/icons/flagpt.svg")),
    _flagru = _interopRequireDefault(require("../../../../assets/icons/flagru.svg")),
    _flagtr = _interopRequireDefault(require("../../../../assets/icons/flagtr.svg")),
    _flaguk = _interopRequireDefault(require("../../../../assets/icons/flaguk.svg")),
    _flagus = _interopRequireDefault(require("../../../../assets/icons/flagus.svg")),
    _flagsg = _interopRequireDefault(require("../../../../assets/icons/flagsg.svg")),
    _flagzh = _interopRequireDefault(require("../../../../assets/icons/flagzh.svg")),
    _folder = _interopRequireDefault(require("../../../../assets/icons/folder.svg")),
    _forward = _interopRequireDefault(require("../../../../assets/icons/forward10.svg")),
    _fullscreen = _interopRequireDefault(require("../../../../assets/icons/fullscreen.svg")),
    _ghost = _interopRequireDefault(require("../../../../assets/icons/ghost.svg")),
    _grid = _interopRequireDefault(require("../../../../assets/icons/grid.svg")),
    _group = _interopRequireDefault(require("../../../../assets/icons/group.svg")),
    _guide = _interopRequireDefault(require("../../../../assets/icons/guide.svg")),
    _hd = _interopRequireDefault(require("../../../../assets/icons/hd.svg")),
    _igtv = _interopRequireDefault(require("../../../../assets/icons/igtv.svg")),
    _image = _interopRequireDefault(require("../../../../assets/icons/image.svg")),
    _import = _interopRequireDefault(require("../../../../assets/icons/import.svg")),
    _info = _interopRequireDefault(require("../../../../assets/icons/info.svg")),
    _inspiration = _interopRequireDefault(require("../../../../assets/icons/inspiration.svg")),
    _intaccess = _interopRequireDefault(require("../../../../assets/icons/intaccess.svg")),
    _italic = _interopRequireDefault(require("../../../../assets/icons/italic.svg")),
    _label = _interopRequireDefault(require("../../../../assets/icons/label.svg")),
    _learning = _interopRequireDefault(require("../../../../assets/icons/learning.svg")),
    _link = _interopRequireDefault(require("../../../../assets/icons/link.svg")),
    _linkedin = _interopRequireDefault(require("../../../../assets/icons/linkedin.svg")),
    _list = _interopRequireDefault(require("../../../../assets/icons/list.svg")),
    _logos = _interopRequireDefault(require("../../../../assets/icons/logos.svg")),
    _longform = _interopRequireDefault(require("../../../../assets/icons/longform.svg")),
    _master = _interopRequireDefault(require("../../../../assets/icons/master.svg")),
    _maximum = _interopRequireDefault(require("../../../../assets/icons/maximum.svg")),
    _medialibrary = _interopRequireDefault(require("../../../../assets/icons/medialibrary.svg")),
    _mediareport = _interopRequireDefault(require("../../../../assets/icons/mediareport.svg")),
    _menucol = _interopRequireDefault(require("../../../../assets/icons/menucol.svg")),
    _menuexp = _interopRequireDefault(require("../../../../assets/icons/menuexp.svg")),
    _message = _interopRequireDefault(require("../../../../assets/icons/message.svg")),
    _minimum = _interopRequireDefault(require("../../../../assets/icons/minimum.svg")),
    _mobile = _interopRequireDefault(require("../../../../assets/icons/mobile.svg")),
    _move = _interopRequireDefault(require("../../../../assets/icons/move.svg")),
    _negative = _interopRequireDefault(require("../../../../assets/icons/negative.svg")),
    _notes = _interopRequireDefault(require("../../../../assets/icons/notes.svg")),
    _notifications = _interopRequireDefault(require("../../../../assets/icons/notifications.svg")),
    _options = _interopRequireDefault(require("../../../../assets/icons/options.svg")),
    _orgadmin = _interopRequireDefault(require("../../../../assets/icons/orgadmin.svg")),
    _organisation = _interopRequireDefault(require("../../../../assets/icons/organisation.svg")),
    _owner = _interopRequireDefault(require("../../../../assets/icons/owner.svg")),
    _package = _interopRequireDefault(require("../../../../assets/icons/package.svg")),
    _padlock = _interopRequireDefault(require("../../../../assets/icons/padlock.svg")),
    _pause = _interopRequireDefault(require("../../../../assets/icons/pause.svg")),
    _platinum = _interopRequireDefault(require("../../../../assets/icons/platinum.svg")),
    _play = _interopRequireDefault(require("../../../../assets/icons/play.svg")),
    _positive = _interopRequireDefault(require("../../../../assets/icons/positive.svg")),
    _previous = _interopRequireDefault(require("../../../../assets/icons/previous.svg")),
    _prevpage = _interopRequireDefault(require("../../../../assets/icons/prevpage.svg")),
    _professional = _interopRequireDefault(require("../../../../assets/icons/professional.svg")),
    _projects = _interopRequireDefault(require("../../../../assets/icons/projects.svg")),
    _publish = _interopRequireDefault(require("../../../../assets/icons/publish.svg")),
    _quoteleft = _interopRequireDefault(require("../../../../assets/icons/quoteleft.svg")),
    _quoteright = _interopRequireDefault(require("../../../../assets/icons/quoteright.svg")),
    _recent = _interopRequireDefault(require("../../../../assets/icons/recent.svg")),
    _recommended = _interopRequireDefault(require("../../../../assets/icons/recommended.svg")),
    _remove = _interopRequireDefault(require("../../../../assets/icons/remove.svg")),
    _report = _interopRequireDefault(require("../../../../assets/icons/report.svg")),
    _return = _interopRequireDefault(require("../../../../assets/icons/return.svg")),
    _review = _interopRequireDefault(require("../../../../assets/icons/review.svg")),
    _rewind = _interopRequireDefault(require("../../../../assets/icons/rewind.svg")),
    _rewind2 = _interopRequireDefault(require("../../../../assets/icons/rewind10.svg")),
    _robot = _interopRequireDefault(require("../../../../assets/icons/robot.svg")),
    _rollover = _interopRequireDefault(require("../../../../assets/icons/rollover.svg")),
    _rushedit = _interopRequireDefault(require("../../../../assets/icons/rushedit.svg")),
    _rushsuper = _interopRequireDefault(require("../../../../assets/icons/rushsuper.svg")),
    _script = _interopRequireDefault(require("../../../../assets/icons/script.svg")),
    _sd = _interopRequireDefault(require("../../../../assets/icons/sd.svg")),
    _search = _interopRequireDefault(require("../../../../assets/icons/search.svg")),
    _settings = _interopRequireDefault(require("../../../../assets/icons/settings.svg")),
    _share = _interopRequireDefault(require("../../../../assets/icons/share.svg")),
    _shootstacolour = _interopRequireDefault(require("../../../../assets/icons/shootstacolour.svg")),
    _shootstadef = _interopRequireDefault(require("../../../../assets/icons/shootstadef.svg")),
    _shootstagrad = _interopRequireDefault(require("../../../../assets/icons/shootstagrad.svg")),
    _shot = _interopRequireDefault(require("../../../../assets/icons/shot.svg")),
    _show = _interopRequireDefault(require("../../../../assets/icons/show.svg")),
    _skip = _interopRequireDefault(require("../../../../assets/icons/skip.svg")),
    _social = _interopRequireDefault(require("../../../../assets/icons/social.svg")),
    _speaker = _interopRequireDefault(require("../../../../assets/icons/speaker.svg")),
    _speakermax = _interopRequireDefault(require("../../../../assets/icons/speakermax.svg")),
    _speakermin = _interopRequireDefault(require("../../../../assets/icons/speakermin.svg")),
    _speakermute = _interopRequireDefault(require("../../../../assets/icons/speakermute.svg")),
    _square = _interopRequireDefault(require("../../../../assets/icons/square.svg")),
    _standard = _interopRequireDefault(require("../../../../assets/icons/standard.svg")),
    _statistics = _interopRequireDefault(require("../../../../assets/icons/statistics.svg")),
    _storyboard = _interopRequireDefault(require("../../../../assets/icons/storyboard.svg")),
    _subscription = _interopRequireDefault(require("../../../../assets/icons/subscription.svg")),
    _subtitle = _interopRequireDefault(require("../../../../assets/icons/subtitle.svg")),
    _success = _interopRequireDefault(require("../../../../assets/icons/success.svg")),
    _tablet = _interopRequireDefault(require("../../../../assets/icons/tablet.svg")),
    _tags = _interopRequireDefault(require("../../../../assets/icons/tags.svg")),
    _teamadmin = _interopRequireDefault(require("../../../../assets/icons/teamadmin.svg")),
    _template = _interopRequireDefault(require("../../../../assets/icons/template.svg")),
    _thumbdown = _interopRequireDefault(require("../../../../assets/icons/thumbdown.svg")),
    _thumbup = _interopRequireDefault(require("../../../../assets/icons/thumbup.svg")),
    _trash = _interopRequireDefault(require("../../../../assets/icons/trash.svg")),
    _trophy = _interopRequireDefault(require("../../../../assets/icons/trophy.svg")),
    _twitter = _interopRequireDefault(require("../../../../assets/icons/twitter2.svg")),
    _twitter2 = _interopRequireDefault(require("../../../../assets/icons/twitter.svg")),
    _typography = _interopRequireDefault(require("../../../../assets/icons/typography.svg")),
    _underline = _interopRequireDefault(require("../../../../assets/icons/underline.svg")),
    _unlimited = _interopRequireDefault(require("../../../../assets/icons/unlimited.svg")),
    _user = _interopRequireDefault(require("../../../../assets/icons/user.svg")),
    _video = _interopRequireDefault(require("../../../../assets/icons/video.svg")),
    _videocamera = _interopRequireDefault(require("../../../../assets/icons/videocamera.svg")),
    _vidres = _interopRequireDefault(require("../../../../assets/icons/vidres.svg")),
    _web = _interopRequireDefault(require("../../../../assets/icons/web.svg")),
    _widescreen = _interopRequireDefault(require("../../../../assets/icons/widescreen.svg")),
    _wistia = _interopRequireDefault(require("../../../../assets/icons/wistia.svg")),
    _youtube = _interopRequireDefault(require("../../../../assets/icons/youtube.svg")),
    _default = {
  activity: _activity["default"],
  addfat: _addfat["default"],
  addthin: _addthin["default"],
  admin: _admin["default"],
  alert: _alert["default"],
  aligncenter: _aligncenter["default"],
  alignjustified: _alignjustified["default"],
  alignleft: _alignleft["default"],
  alignright: _alignright["default"],
  analytics: _analytics["default"],
  apps: _apps["default"],
  arabic: _arabic["default"],
  arrowdown: _arrowdown["default"],
  arrowleft: _arrowleft["default"],
  arrowright: _arrowright["default"],
  arrowup: _arrowup["default"],
  at: _at["default"],
  audio: _audio["default"],
  bookings: _bookings["default"],
  bookmark: _bookmark["default"],
  brand: _brand["default"],
  brief: _brief["default"],
  briefbasic: _briefbasic["default"],
  briefexact: _briefexact["default"],
  brightcove: _brightcove["default"],
  broadcast: _broadcast["default"],
  brokenlink: _brokenlink["default"],
  blockquote: _blockquote["default"],
  bold: _bold["default"],
  bulletlist: _bulletlist["default"],
  bulletnumeric: _bulletnumeric["default"],
  camera: _camera["default"],
  captions: _captions["default"],
  chevrondown: _chevrondown["default"],
  chevronleft: _chevronleft["default"],
  chevronright: _chevronright["default"],
  chevronup: _chevronup["default"],
  childpage: _childpage["default"],
  chromakey: _chromakey["default"],
  close: _close["default"],
  colour: _colour["default"],
  corrupt: _corrupt["default"],
  comments: _comments["default"],
  company: _company["default"],
  computer: _computer["default"],
  contract: _contract["default"],
  creative: _creative["default"],
  credits: _credits["default"],
  dashboard: _dashboard["default"],
  defscreen: _defscreen["default"],
  desktop: _desktop["default"],
  document: _document["default"],
  download: _download["default"],
  duplicate: _duplicate["default"],
  edit: _edit["default"],
  editing: _editing["default"],
  email: _email["default"],
  embed: _embed["default"],
  exit: _exit["default"],
  expand: _expand["default"],
  export: _export["default"],
  extrafootage: _extrafootage["default"],
  facebook: _facebook["default"],
  facebook2: _facebook2["default"],
  faq: _faq["default"],
  fastforward: _fastforward["default"],
  favempty: _favempty["default"],
  favfull: _favfull["default"],
  favourite: _favourite["default"],
  flag: _flag["default"],
  flagar: _flagar["default"],
  flagaus: _flagaus["default"],
  flagbr: _flagbr["default"],
  flagch: _flagch["default"],
  flagcs: _flagcs["default"],
  flagcz: _flagcz["default"],
  flagde: _flagde["default"],
  flagdu: _flagdu["default"],
  flages: _flages["default"],
  flageuro: _flageuro["default"],
  flagfr: _flagfr["default"],
  flaggen: _flaggen["default"],
  flaggpt: _flaggpt["default"],
  flagit: _flagit["default"],
  flagja: _flagja["default"],
  flagjp: _flagjp["default"],
  flagko: _flagko["default"],
  flagkr: _flagkr["default"],
  flagnl: _flagnl["default"],
  flagpl: _flagpl["default"],
  flagpt: _flagpt["default"],
  flagru: _flagru["default"],
  flagtr: _flagtr["default"],
  flaguk: _flaguk["default"],
  flagus: _flagus["default"],
  flagsg: _flagsg["default"],
  flagzh: _flagzh["default"],
  folder: _folder["default"],
  forward10: _forward["default"],
  fullscreen: _fullscreen["default"],
  ghost: _ghost["default"],
  grid: _grid["default"],
  group: _group["default"],
  guide: _guide["default"],
  hd: _hd["default"],
  igtv: _igtv["default"],
  image: _image["default"],
  import: _import["default"],
  info: _info["default"],
  inspiration: _inspiration["default"],
  intaccess: _intaccess["default"],
  italic: _italic["default"],
  label: _label["default"],
  learning: _learning["default"],
  link: _link["default"],
  linkedin: _linkedin["default"],
  list: _list["default"],
  logos: _logos["default"],
  longform: _longform["default"],
  master: _master["default"],
  maximum: _maximum["default"],
  medialibrary: _medialibrary["default"],
  mediareport: _mediareport["default"],
  menucol: _menucol["default"],
  menuexp: _menuexp["default"],
  message: _message["default"],
  minimum: _minimum["default"],
  mobile: _mobile["default"],
  move: _move["default"],
  negative: _negative["default"],
  notes: _notes["default"],
  notifications: _notifications["default"],
  options: _options["default"],
  orgadmin: _orgadmin["default"],
  organisation: _organisation["default"],
  owner: _owner["default"],
  package: _package["default"],
  padlock: _padlock["default"],
  pause: _pause["default"],
  platinum: _platinum["default"],
  play: _play["default"],
  positive: _positive["default"],
  previous: _previous["default"],
  prevpage: _prevpage["default"],
  professional: _professional["default"],
  projects: _projects["default"],
  publish: _publish["default"],
  quoteleft: _quoteleft["default"],
  quoteright: _quoteright["default"],
  recent: _recent["default"],
  recommended: _recommended["default"],
  remove: _remove["default"],
  report: _report["default"],
  return: _return["default"],
  review: _review["default"],
  rewind: _rewind["default"],
  rewind10: _rewind2["default"],
  robot: _robot["default"],
  rollover: _rollover["default"],
  rushedit: _rushedit["default"],
  rushsuper: _rushsuper["default"],
  script: _script["default"],
  sd: _sd["default"],
  search: _search["default"],
  settings: _settings["default"],
  share: _share["default"],
  shootstacolour: _shootstacolour["default"],
  shootstadef: _shootstadef["default"],
  shootstagrad: _shootstagrad["default"],
  shot: _shot["default"],
  show: _show["default"],
  skip: _skip["default"],
  social: _social["default"],
  speaker: _speaker["default"],
  speakermax: _speakermax["default"],
  speakermin: _speakermin["default"],
  speakermute: _speakermute["default"],
  square: _square["default"],
  standard: _standard["default"],
  statistics: _statistics["default"],
  storyboard: _storyboard["default"],
  subscription: _subscription["default"],
  subtitle: _subtitle["default"],
  success: _success["default"],
  tablet: _tablet["default"],
  tags: _tags["default"],
  teamadmin: _teamadmin["default"],
  template: _template["default"],
  thumbdown: _thumbdown["default"],
  thumbup: _thumbup["default"],
  trash: _trash["default"],
  trophy: _trophy["default"],
  twitter: _twitter2["default"],
  twitter2: _twitter["default"],
  typography: _typography["default"],
  underline: _underline["default"],
  unlimited: _unlimited["default"],
  user: _user["default"],
  video: _video["default"],
  videocamera: _videocamera["default"],
  vidres: _vidres["default"],
  web: _web["default"],
  widescreen: _widescreen["default"],
  wistia: _wistia["default"],
  youtube: _youtube["default"]
};

exports["default"] = _default;